import { CourseReportFilterI } from 'types';
import { z } from 'zod';

export const coursesReportsSchema = z.object({
  name: z.string().optional(),
  prioritiesId: z.string().optional(),
  page: z.number().optional(),
  pageSize: z.number().optional(),
});

export const defaultValues: CourseReportFilterI = {
  name: undefined,
  prioritiesId: undefined,
};
